import React, { useEffect } from 'react';

export default function InstagramEmbed({ permalink }) {
	useEffect(() => {
		// If the Instagram script is already loaded on the page, process the embed
		if (window.instgrm) {
			window.instgrm.Embeds.process();
		} else {
			// Otherwise, dynamically inject Instagram's official script once
			const script = document.createElement('script');
			script.src = '//www.instagram.com/embed.js';
			script.async = true;
			document.body.appendChild(script);
		}
	}, [permalink]);

	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				margin: '2rem 0',
			}}
		>
			<blockquote
				className="instagram-media"
				data-instgrm-permalink={permalink}
				data-instgrm-version="14"
				style={{
					background: '#1f2937', // Matches your dark theme base!
					border: '1px solid #374151',
					borderRadius: '8px',
					boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
					margin: '0 auto',
					maxWidth: '540px',
					width: '100%',
					overflow: 'hidden',
				}}
			>
				<a
					href={permalink}
					target="_blank"
					rel="noopener noreferrer"
					style={{
						color: '#9ca3af',
						textDecoration: 'none',
						padding: '1rem',
						display: 'block',
						textAlign: 'center',
					}}
				>
					View this post on Instagram
				</a>
			</blockquote>
		</div>
	);
}
